module.exports = __webpack_public_path__ + "static/media/spinner.1f024880.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/spinner.svg
// module id = 103
// module chunks = 0